import PropTypes from "prop-types";
import React, { Component } from "react";
import { Menu } from "@material-ui/core";
import Button from "./button";
import { merge, $ } from "glamor";

const styles = {
    base: {},
    button: {
        paddingRight: "32px",
    },
};
const position = {
    top: "top",
    bottom: "bottom",
    left: "left",
    right: "right",
    center: "center",
};
const anchorOriginPosition = {
    horizontal: position.right,
    vertical: position.bottom,
};
const transformOriginPosition = {
    horizontal: position.right,
    vertical: position.top,
};

/** @augments {Component<any, any>} */

class Dropdown extends Component {
    styles = merge(
        $(" button > div", {
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
    );

    static propTypes = {
        label: PropTypes.string.isRequired,
        children: PropTypes.node,
        onToggle: PropTypes.func,
        buttonStyle: PropTypes.object,
        dropdownIconStyles: PropTypes.object,
        disabled: PropTypes.bool,
        disabledButtonStyle: PropTypes.object,
        disabledLabelStyle: PropTypes.object,
        disabledIconStyle: PropTypes.object,
        fullWidth: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    handleTouchTap = (e) => {
        e.preventDefault();

        this.setState({
            open: true,
            anchorEl: e.currentTarget,
        });

        if (this.props.onToggle) {
            this.props.onToggle(true);
        }
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
        });

        if (this.props.onToggle) {
            this.props.onToggle(false);
        }
    };

    render() {
        const {
            label,
            style,
            children,
            onToggle, // not used but want to exclude
            buttonStyle,
            labelStyle,
            className,
            disabledButtonStyle = {},
            disabledLabelStyle = {},
            disabledIconStyle = {},
            status,
            fullWidth = false,
            ...other
        } = this.props;

        const { open, anchorEl } = this.state;

        return (
            <div className={className} style={Object.assign({}, styles.base, style)} {...this.styles}>
                <Button
                    {...other}
                    style={Object.assign(
                        {},
                        styles.button,
                        buttonStyle,
                        this.props.disabled ? disabledButtonStyle : {},
                        fullWidth ? { width: "100%" } : {},
                    )}
                    labelStyle={{ ...labelStyle, ...(this.props.disabled ? disabledLabelStyle : {}) }}
                    dropdownIconStyles={this.props.disabled ? disabledIconStyle : {}}
                    hoverColor="#fff"
                    label={label}
                    dropdown={true}
                    onClick={this.handleTouchTap}
                />
                {status !== "loading" && (
                    <Menu
                        open={open}
                        style={{ ...menuStyles.root }}
                        anchorEl={anchorEl}
                        getContentAnchorEl={null}
                        anchorOrigin={anchorOriginPosition}
                        transformOrigin={transformOriginPosition}
                        onClose={this.handleRequestClose}
                    >
                        {children}
                    </Menu>
                )}
            </div>
        );
    }
}

const menuStyles = {
    root: {
        zIndex: 2600,
    },
};

export default Dropdown;
